import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Appointment } from '../../../core/models/appointment.model';
import { AppointmentStatus } from '../../../core/enums/appointment-status.enum';
import { AgePipe } from '../../../core/pipes/age.pipe';
import { DatePipe, NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-booking-card',
  templateUrl: './booking-card.html',
  imports: [AgePipe, DatePipe, NgClass, NgIf],
  styleUrls: ['./booking-card.scss'],
})
export class BookingCardComponent {
  @Input() booking!: Appointment;
  @Input() statusClass = '';
  @Input() canComplete = false;
  @Output() view = new EventEmitter<Appointment>();
  @Output() start = new EventEmitter<Appointment>();
  @Output() cancel = new EventEmitter<Appointment>();
  @Output() complete = new EventEmitter<Appointment>();
  @Output() noShow = new EventEmitter<Appointment>();

  status = AppointmentStatus;

  onView() {
    this.view.emit(this.booking);
  }

  onStart() {
    this.start.emit(this.booking);
  }

  onCancel() {
    this.cancel.emit(this.booking);
  }

  onComplete() {
    this.complete.emit(this.booking);
  }

  onNoShow() {
    this.noShow.emit(this.booking);
  }

  onImgError(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/images/default-avatar.png';
  }

  protected readonly AppointmentStatus = AppointmentStatus;
}
